export default {"src":"/_next/static/media/coco-customer-service.dd6b5ef6.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};